export default "__VITE_ASSET__DUrSTf_Q__"